import React, { useState } from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { resendConfirmationThunk } from '../redux/userSlice'
import { AppDispatch } from '../store'
import { Button } from '../components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card'
import { toast } from '@/components/ui/sonner'

const useAppDispatch = () => useDispatch<AppDispatch>()

const VerifyEmail: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [isLoading, setIsLoading] = useState(false)

  // Extract email from location state
  const email = location.state?.email

  if (!email) {
    // Redirect if email is not available, as it's required for this page
    navigate('/signup')
    return null
  }

  const handleResendEmail = async () => {
    setIsLoading(true)
    try {
      await dispatch(resendConfirmationThunk(email)).unwrap()
      toast.success('A new confirmation email has been sent.')
    } catch (err: any) {
      toast.error(err || 'Failed to resend email. Please try again.')
    }
    setIsLoading(false)
  }

  return (
    <div className="flex items-center justify-center min-h-screen relative">
      <div className="fixed inset-0 -z-10 bg-linear-to-br from-[#000000] via-[#0a1e29] to-[#003b4d]"></div>

      <div className="w-full max-w-md px-4">
        <Card variant="dark">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <img
                src="https://adthlete.us-iad-1.linodeobjects.com/public/adthlete_logomark.png"
                alt="Athios Logo"
                className="w-10 h-10"
              />
            </div>
            <CardTitle className="text-3xl font-black text-white tracking-tight">
              Check Your Email
            </CardTitle>
            <CardDescription className="mt-2 text-gray-400">
              We've sent a confirmation link to <strong className="text-white">{email}</strong>.
              <br />
              Please check your inbox (and spam folder).
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Button
              onClick={handleResendEmail}
              disabled={isLoading}
              variant="lime"
              className="w-full font-medium"
            >
              {isLoading ? 'Sending...' : 'Resend Confirmation Email'}
            </Button>
            <div className="text-center">
              <p className="text-gray-400 text-sm">
                Wrong email?{' '}
                <Link
                  to="/signup/step2"
                  className="text-[#C0FD72] hover:text-[#a8e45a] font-medium"
                >
                  Go back to edit
                </Link>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default VerifyEmail
